module.exports = __webpack_public_path__ + "static/less-issues-0ac97330c824d0177237cc433cf6796b.png";